/* eslint-disable react-hooks/exhaustive-deps */

import React, { useMemo, useEffect, useState } from "react";
import BaseView from "../BaseView";
import NavBar from "./NavBar";
import PurposeList from "./PurposeList";
import { useDisclosure } from "@chakra-ui/react";
import PurposesEditModal from "./PurposeEditModal";
import { usePurposeApi } from "./usePurpoeApi";
import { usePurposeUI } from "./usePurposeUI";
import { FormattedMessage, useIntl } from "react-intl";
import NewItemButton from "src/components/NewItemButton";
import PurposeCreateModal from "./PurposeCreateModal";
import { useCreatePurpose } from "./useCreatePurpose";
import { useEditPurpose } from "./useEditPurpose";
import { valuesBg } from "src/assets/icons";
import { useAppContext } from "../../../Providers";
import SharingModal from "src/components/SharingModal/SharingModal";
import { useFreeTrialToast } from "src/store/hooks/useFreeTrialToast";
import FreeTrialLock from "src/components/FreeTrialLock";
import { useFreeTrial } from "src/free-trial/helpers";

const Purposes: React.FC = () => {
  const context = useAppContext();
  const { formatMessage } = useIntl();
  const { showFreeTrialToast } = useFreeTrialToast();

  // console.log(user);

  useEffect(() => {
    context.background?.set("#fff");
  });
  const {
    currentId,
    currentListTypeState,
    editDisclosureProps,
    createDisclosureProps,
  } = usePurposeUI();

  const { listQuery, mutations, currentPurposeQuery } =
    usePurposeApi(currentId);

  useEffect(() => {
    currentPurposeQuery.data?.selectedAspects?.sort((a, b) =>
      a.completed && !b.completed ? -1 : 1
    );
  }, [currentPurposeQuery]);

  const { createHandler } = useCreatePurpose({
    openEditModal: editDisclosureProps.onOpen,
    dismissCreateModal: createDisclosureProps.onClose,
    createMutation: mutations.createMutation,
  });
  const editProps = useEditPurpose({
    id: currentId,
    editMutation: mutations.editMutation,
    currentPurpose: currentPurposeQuery?.data,
    addAspectMutation: mutations.addAspectMutation,
    addTargetMutation: mutations.addTargetMutation,
    selectTargetMutation: mutations.selectTargetMutation,
    selectValuesMatrix: mutations.mutateValuesMatrix,
    saveNote: mutations.saveNoteMutation,
  });

  //state to indicate that the purpose had been reset
  const [isReset, setIsReset] = useState(0);
  const {
    isOpen: isSharingModalOpen,
    onClose: onSharingModalClose,
    onOpen: onSharingModalOpen,
  } = useDisclosure();
  const [currentList, setCurrentList] = useState<any>({ id: 0, name: "" });
  const [sharingProps, setSharingProps] = useState<any>();
  const onShare: any = ({ id, name }) => {
    onSharingModalOpen();
    setCurrentList({ id, name });
  };

  const { hasPermission: shouldUserAddPurpose } = useFreeTrial(
    listQuery.completedList.length
  );

  const listActions = useMemo(() => {
    //TODO
    return {
      removePurposeHandler: async (id: number) => {
        mutations.deletePurposeMutation(id);
      },
      archive: (id: number) => {
        return mutations.archiveMutation(id);
      },
      reset: async (id: number) => {
        await mutations.purposeResetMutation({ purposeId: id });
        setIsReset(id);
        return Promise.resolve();
      },
      unarchive: (id: number) => {
        return mutations.unarchiveMutation(id);
      },
      incompleteItemOnClick: (id: number) => editDisclosureProps.onOpen(id),
      completeArchiveItemOnClick: (id: number) =>
        editDisclosureProps.onOpen(id),
    };
  }, [editDisclosureProps, mutations]);

  useEffect(() => {
    // open the edit dialog when resetting the message
    if (isReset) {
      editDisclosureProps.onOpen(isReset);
    }
  }, [isReset]);

  return (
    <>
      <BaseView imageSrc={valuesBg}>
        <FreeTrialLock isLocked={!shouldUserAddPurpose} lockSpacing={5}>
          <NewItemButton
            onClick={() => {
              if (!shouldUserAddPurpose) {
                showFreeTrialToast({
                  message: formatMessage({
                    id: "freeTrial.purposesLimitReached",
                  }),
                });
                return;
              }
              createDisclosureProps.onOpen();
            }}
          >
            <FormattedMessage
              id="purpose.create"
              defaultMessage="إضافة رسالة جديدة"
            />
          </NewItemButton>
        </FreeTrialLock>
        <NavBar state={currentListTypeState} />
        <PurposeList
          {...listQuery}
          onShare={onShare}
          setSharingProps={setSharingProps}
          currentType={currentListTypeState[0]}
          listActions={listActions}
        />
      </BaseView>
      <SharingModal
        isOpen={isSharingModalOpen}
        onClose={onSharingModalClose}
        sharedEntity={{ name: "message", id: currentList.id }}
        showOptions={true}
      />
      <PurposeCreateModal
        disclosureProps={createDisclosureProps}
        createHandler={createHandler}
      />
      <PurposesEditModal
        disclosureProps={editDisclosureProps}
        purposeQuery={currentPurposeQuery}
        isReset={isReset}
        isSharedWithMe={sharingProps?.shared?.permission}
        canUpdate={sharingProps?.shared?.permission === "update"}
        {...editProps}
        restoreFn={listActions.reset}
      />
    </>
  );
};
export default Purposes;
